<template>
  <div class="addclient">
    <div class="card-block">
      <form v-if="!waitForData" @submit.prevent="submitForm" data-testid="registration-insurance-form">
        <div class="row justify-content-center">
          <div class="form-group col-md-12">
            <label for="insuranceCompany">Zdravotní pojišťovna:</label>
            <multiselect id="insuranceCompany" data-testid="registration-insurance-company" v-model="selectedInsuranceCompany" props="options" :options="insuranceCompanies" track-by="name" label="name" placeholder="vybrat pojišťovnu" :option-height="104" open-direction="down" :custom-label="customLabel" :show-labels="false" TagPlaceholder="" :allow-empty="true" selectLabel="">
              <template slot="option" scope="props">
                <span :data-testid="'registration-insurance-company-option-' + props.option.code">{{ customLabel(props.option) }}</span>
              </template>
            </multiselect>
            <!--<small id="personalidError" class="form-text text-danger" v-if="clientError.pin">{{ clientError.pin.message }}</small>-->
            <label for="insuranceType" class="ml-sm-2 mr-sm-2">Druh: </label>
            <select class="form-control" v-model="insurance.type" id="insuranceType" data-testid="registration-insurance-step-type">
              <option v-for="n in 4" v-bind:value="n">{{ n }} - {{ n | insuranceTypeIntToName }}</option>
            </select>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="form-group col-md-12 text-center">
            <button v-if="selectedInsuranceCompany === null" type="submit" class="btn btn-warning" data-testid="registration-insurance-skip">Přeskočit (bez pojištění)</button>
            <button v-else-if="insurancePending === false" type="submit" class="btn btn-primary" data-testid="registration-insurance-save">Vybrat zdravotní pojišťovnu</button>
            <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
          </div>
        </div>
      </form>
      <div  v-if="waitForData" class="row justify-content-around">
        <div class="">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  export default {
    data () {
      return {
        // insurance companies
        insuranceCompanies: {},
        insuranceCompaniesError: {},
        // insurace
        selectedInsuranceCompany: null,
        insurancePending: false,
        insuranceError: {},
        insurance: {
          insurancecompany: '',
          valid_from: '',
          type: 1
        },
        // client
        clientError: '',
        client: '',
        // others
        setting: require('../../../variables.js'),
        clientid: '',
        waitForResponse: false,
        waitForData: false,
        decodePinPending: false,
        message: '',
        submited: '',
        countries: [],
        citizenship: [],
        healthinsurance: [],
        pinDecodeError: []
      }
    },
    methods: {
      submitForm () {
        if (this.selectedInsuranceCompany === null) {
          this.$emit('completed-step', 2)
        } else {
          this.postInsurance()
        }
        // this.postClient()
      },
      getInsuranceCompanies () {
        this.waitForData = true
        this.$http.get(this.setting.hostname + 'insurance_companies').then(response => {
          this.insuranceCompanies = response.data
          this.waitForData = false
        }).catch(error => {
          this.insuranceCompaniesError = error.response.data.errors
          this.waitForData = false
        })
      },
      customLabel ({ code, name }) {
        return `${code} – ${name}`
      },
      postInsurance () {
        this.insurancePending = true
        this.insurance.insurancecompany = this.selectedInsuranceCompany.code
        this.insurance.valid_from = this.client.birth_date
        this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/insurance', this.insurance, {emulateJSON: true}).then(response => {
          this.insurancePending = false
          this.$emit('completed-step', 2)
        }).catch(error => {
          this.insuranceError = error.response.data.errors
          this.insurancePending = false
        })
      },
      getClient () {
        this.waitForData = true
        this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid).then(response => {
          this.client = response.data
          this.waitForData = false
          if (this.client.health_insurance !== null) {
            this.$emit('completed-step', 2)
          }
        }).catch(error => {
          this.clientError = error.response.data.errors
          this.waitForData = false
        })
      }
      /* putClient () {
       this.waitForResponse = true
       this.submited = 'yeaaa'
       this.$http.put(this.setting.hostname + 'client/' + this.clientid, this.client, {emulateJSON: true}).then(response => {
       this.submited = response.data
       this.clientid = response.data.id
       }, response => {
       this.errors = response.data.errors
       this.waitForResponse = false
       })
       }, */
    },
    beforeMount () {
      this.getInsuranceCompanies()
      this.getClient()
    },
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .icon-male {
    color: dodgerblue;
    font-weight: bold;
  }

  .icon-female {
    color: deeppink;
    font-weight: bold;
  }

  .icon-genderless {
    color: #ccc;
    font-weight: bold;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    vertical-align: middle;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/views/Registration/components/RegistrationClientInsurance.vue?e3becd24